export const SHOULD_SHOW_CONFIGURATION_MODAL = 'shouldShowConfigurationModal';
